import InputWithCTAButton from './InputWithCTAButton';

export default InputWithCTAButton;
